import Layout from '@/layout'

const tradeRouter = {
  path: '',
  component: Layout,
  redirect: 'trade',
  name: '交易记录',
  meta: {
    title: '交易记录',
    icon: 'el-icon-s-home'
  },
  children: [
    {
      path: 'trade',
      name: 'trade',
      meta: {
        title: '交易记录'
      },
      component: () => import('@/views/trade')
    },
    {
      path: 'accountDetails',
      name: 'accountDetails',
      meta: {
        title: '账户明细'
      },
      component: () => import('@/views/index/accountDetails.vue')
    }
  ]
}

export default tradeRouter
